import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';

// THIN-7247: per-axis assignment sagas. They reuse the existing
// SUCCESS/FAILURE/LOADING action types from the call-submission flow so the
// existing callSubmitEventReducer continues to drive consumer UIs (the
// select-supervisor modal listens for isEventCalled to flip before closing).
const {
  REQUEST_ASSIGN_SUPERVISOR,
  REQUEST_ASSIGN_PHYSICIAN,
  SUCCESS_CALL_SUBMISSION_EVENT,
  FAILURE_CALL_SUBMISSION_EVENT,
  LOADING_SAVE_SUBMISSION,
} = documentationActions;

function* assignSupervisor(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_SAVE_SUBMISSION });
    const response = yield call(templateService.assignSupervisor, action.params);
    if (response?.status === 201) {
      yield put({ type: SUCCESS_CALL_SUBMISSION_EVENT, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_CALL_SUBMISSION_EVENT, payload: error });
  }
}

function* assignPhysician(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_SAVE_SUBMISSION });
    const response = yield call(templateService.assignPhysician, action.params);
    if (response?.status === 201) {
      yield put({ type: SUCCESS_CALL_SUBMISSION_EVENT, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_CALL_SUBMISSION_EVENT, payload: error });
  }
}

function* assignSignerSaga() {
  yield takeEvery(REQUEST_ASSIGN_SUPERVISOR, assignSupervisor);
  yield takeEvery(REQUEST_ASSIGN_PHYSICIAN, assignPhysician);
}

export default assignSignerSaga;
